import { render, staticRenderFns } from "./Toats.vue?vue&type=template&id=4a19b1a0&"
import script from "./Toats.vue?vue&type=script&lang=js&"
export * from "./Toats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports